import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {faRadar} from '@fortawesome/pro-light-svg-icons';
import {WorkbenchPlugin, WorkbenchPluginId, WorkbenchViewKind} from '../../shared/types';
import {WorkbenchLayoutManager} from '../../shared/services/workbench-layout-manager.service';
import {WorkbenchCommandRegistry} from '../../shared/services/workbench-command-registry.service';
import {QualitySenseObservationsViewComponent} from './views/quality-sense-observations-view.component';
import {
    QUALITY_SENSE_OBSERVATIONS_VIEW_ID,
    QUALITY_SENSE_TOGGLE_COMMAND_ID,
    QUALITY_SENSE_VIEW_CONTAINER_ID
} from './quality-sense-ids';

@Injectable()
export class QualitySensePlugin extends WorkbenchPlugin {
    static readonly ViewContainerId = QUALITY_SENSE_VIEW_CONTAINER_ID;
    static readonly ObservationsViewId = QUALITY_SENSE_OBSERVATIONS_VIEW_ID;
    static readonly ToggleCommandId = QUALITY_SENSE_TOGGLE_COMMAND_ID;

    id: WorkbenchPluginId = 'quality-sense';
    views: WorkbenchViewKind[] = [{
        id: QualitySensePlugin.ObservationsViewId,
        component: QualitySenseObservationsViewComponent,
        name: 'Observations',
        defaultViewContainer: QualitySensePlugin.ViewContainerId,
        visibility: 'generic'
    }];

    constructor(readonly layoutManager: WorkbenchLayoutManager,
                private readonly commandRegistry: WorkbenchCommandRegistry) {
        super(layoutManager);
    }

    onWorkbenchInit(): Observable<void> {
        this.layoutManager.registerViewContainer({
            type: 'NormalViewContainer',
            id: QualitySensePlugin.ViewContainerId,
            name: 'QualitySense',
            icon: {
                type: 'faIcon',
                instance: faRadar
            },
            allowedPanels: ['bottom'],
            defaultPanel: 'bottom',
            displayMode: 'standalone',
            moveAllowed: false,
            splitAllowed: false,
            toolbarCommandId: QualitySensePlugin.ToggleCommandId
        });

        this.commandRegistry.registerCommand(
            QualitySensePlugin.ToggleCommandId,
            {
                name: 'QualitySense',
                icon: {
                    type: 'faIcon',
                    instance: faRadar
                },
                description: 'Toggle QualitySense observations',
                statusBindings: {
                    active: {
                        type: 'store',
                        storeKey: `viewcontainers.${QualitySensePlugin.ViewContainerId}.status.visible`
                    }
                }
            },
            () => this.layoutManager.toggleViewContainer(QualitySensePlugin.ViewContainerId, true)
        );

        return of(undefined);
    }

    onWorkbenchDestroy(): void {
    }
}
